var _path, _path2, _path3, _path4, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 36,
    viewBox: "0 0 37 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.8944 18.3818C36.6715 15.7794 35.7919 13.2574 34.3302 11.0692C33.1492 9.30341 31.6915 7.81514 30.0275 6.64062C29.854 7.16352 29.5608 7.65425 29.1355 8.08062L28.5203 8.69603C26.4061 6.36307 23.3256 4.86274 19.8488 4.81447C16.0912 4.7662 12.6721 6.47972 10.4753 9.18676C11.8999 10.0516 13.7003 10.1883 15.257 9.47235C17.0285 8.65581 19.0395 8.26162 21.1371 8.41447C23.272 8.57134 25.2334 9.27525 26.8809 10.3814C30.2959 12.6661 32.3894 16.6442 31.9641 20.9441C31.7287 23.3293 30.7459 25.4853 29.2594 27.2069L29.4865 27.4201C29.8127 27.7298 30.1761 27.9671 30.5601 28.1401C32.4266 28.9767 34.772 28.2004 35.6433 26.2093C36.6797 23.804 37.1298 21.1372 36.8944 18.3818Z",
    fill: "url(#paint0_linear_271_1870)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.4132 2.38115C26.0224 0.953216 23.2764 0.132657 20.3859 0.0160094C16.1162 -0.160974 11.9168 1.28305 8.70007 4.03031C7.79163 4.80662 6.9823 5.65936 6.28032 6.58048C7.18463 6.68506 8.07242 7.06718 8.79092 7.75098L8.92718 7.8797C6.53221 9.93914 4.99199 12.9398 4.94243 16.3266C4.88875 20.2766 6.941 23.8404 10.1123 25.9441C10.4302 24.6287 10.2403 23.2089 9.51354 21.978C8.33257 19.9829 7.75034 17.6218 8.00223 15.136C8.22934 12.8915 9.12126 10.8482 10.4757 9.18294C12.6766 6.4759 16.0915 4.76238 19.8491 4.81065C23.326 4.85489 26.4064 6.35523 28.5206 8.69221L29.1358 8.07679C29.5612 7.65444 29.8585 7.1597 30.0278 6.63679C30.5398 5.09221 29.9576 3.30227 28.4132 2.38115Z",
    fill: "url(#paint1_linear_271_1870)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M31.9605 20.9482C32.3858 16.6483 30.2964 12.6662 26.8773 10.3855C26.0185 11.4957 25.8698 13.0081 26.5676 14.251C27.6206 16.1214 28.1492 18.3015 27.9716 20.5902C27.8312 22.4364 27.2407 24.1459 26.3199 25.6302C24.0529 29.2825 19.7626 31.5672 15.1089 31.1328C12.6603 30.9035 10.447 29.9462 8.67963 28.4981C8.67963 28.4981 8.67963 28.4981 8.6755 28.4981L8.51033 28.663C8.07676 29.0975 7.77532 29.5962 7.60189 30.1191C7.01141 31.889 7.84139 33.9484 9.76976 34.7368C12.2225 35.7383 14.9355 36.1687 17.7351 35.9395C20.4068 35.7223 22.9958 34.8655 25.2421 33.4416C27.4596 32.0378 29.2475 30.2237 30.54 28.1442C30.156 27.9712 29.7926 27.7339 29.4664 27.4242L29.2393 27.211C30.7423 25.4894 31.721 23.3334 31.9605 20.9482Z",
    fill: "url(#paint2_linear_271_1870)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22.7604 26.2818C20.671 27.5086 18.1728 28.12 15.5425 27.8666C13.5356 27.6735 11.6857 26.9897 10.1125 25.9439C6.94119 23.8402 4.88894 20.2764 4.94262 16.3265C4.98804 12.9397 6.52826 9.93902 8.92737 7.87957L8.7911 7.75086C8.07261 7.06706 7.18894 6.68494 6.2805 6.58036C4.61641 6.39131 2.88211 7.14348 2.00671 8.72024C0.809217 10.8682 0.123757 13.2735 0.016396 15.7956C-0.165292 19.9587 1.31712 24.0534 4.13741 27.1828C5.1656 28.3252 6.33418 29.3106 7.606 30.1191C7.77943 29.5962 8.08087 29.0975 8.51444 28.663L8.67961 28.4981C8.67961 28.4981 8.67961 28.4981 8.68374 28.4981C10.4511 29.9462 12.6644 30.9035 15.113 31.1328C19.7667 31.5712 24.057 29.2825 26.324 25.6302C25.1265 25.4251 23.8588 25.6342 22.7604 26.2818Z",
    fill: "url(#paint3_linear_271_1870)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_271_1870",
    x1: 16.027,
    y1: 5.63414,
    x2: 35.0447,
    y2: 22.2395,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#75D9EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3278B2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_271_1870",
    x1: 4.94206,
    y1: 12.9726,
    x2: 30.2088,
    y2: 12.9726,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFF8A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7931E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_271_1870",
    x1: 30.6454,
    y1: 15.9148,
    x2: 14.5005,
    y2: 35.2775,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#98DF94"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#25C16F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_271_1870",
    x1: 15.5712,
    y1: 28.3847,
    x2: 7.69079,
    y2: 8.60927,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EE7E3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D33C4E"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.b8d5012ddd5b440e5414bce552b90c83.svg";
export { ForwardRef as ReactComponent };